import { render } from "./read-register-list.vue?vue&type=template&id=d5831824&scoped=true"
import script from "./read-register-list.vue?vue&type=script&lang=js"
export * from "./read-register-list.vue?vue&type=script&lang=js"

import "./read-register-list.vue?vue&type=style&index=0&id=d5831824&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5831824"]])

export default __exports__